import { getUserImageUrl } from './requests/AuthRequests'

/**
 * Renova a fotoUrl (SAS da imagem de perfil) chamando o backend e atualiza o
 * localStorage. O SAS gravado no login expira em ~30min; ao recarregar a página
 * após esse tempo, a imagem dava 403. Esta função busca uma URL fresca.
 *
 * @returns {Promise<string|null>} a nova fotoUrl (pode ser '' se o usuário não
 *   tem foto), ou null em caso de falha (mantém a URL atual do localStorage).
 */
export async function refreshFotoUrl() {
	try {
		const { data } = await getUserImageUrl()
		const fotoUrl = data?.result?.fotoUrl ?? ''
		localStorage.setItem('fotoUrl', fotoUrl)
		return fotoUrl
	} catch {
		return null
	}
}
